import React from "react";
import Board from "./Board";
import calculateWinner from "./helpers/calculateWinner";

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [
        {
          squares: Array(9).fill(null),
        },
      ],
      stepNumber: 0,
      xIsNext: true,
    };
  }

  handleClick(i) {
    const history = this.state.history.slice(0, this.state.stepNumber + 1);
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = this.state.xIsNext ? "X" : "O";
    this.setState({
      history: history.concat([{ squares }]),
      stepNumber: history.length,
      xIsNext: !this.state.xIsNext,
    });
  }

  jumpTo(step) {
    this.setState({
      history: this.state.history.slice(0, step + 1),
      stepNumber: step,
      xIsNext: step % 2 === 0,
    });
  }

  render() {
    const history = this.state.history;
    const current = history[this.state.stepNumber];
    const winner = calculateWinner(current.squares);

    const moves = history.map((step, move) => {
      if (move === 0) return null;

      const desc = "Go to move #" + move;
      return (
        <li key={move}>
          <button
            style={
              move === this.state.stepNumber ? { fontWeight: "bold" } : null
            }
            onClick={() => this.jumpTo(move)}
          >
            {desc}
          </button>
        </li>
      );
    });

    let status;
    if (winner) {
      status = "Winner: " + current.squares[winner[0]];
    } else if (this.state.stepNumber < 9) {
      status = "Next player: " + (this.state.xIsNext ? "X" : "O");
    } else {
      status = "The game is Draw!";
    }
    return (
      <div className="container">
        <div className="game">
          <div className="game-board">
            <div className="squares-container">
              <Board
                squares={current.squares}
                winningCombo={winner}
                onClick={(i) => this.handleClick(i)}
              />
            </div>
          </div>
          <div className="game-info">
            <div>{status}</div>
            <button onClick={() => this.jumpTo(0)}>Start over</button>
            <ol>{moves}</ol>
          </div>
        </div>
      </div>
    );
  }
}

export default Game;
